import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { SettingsProvider } from "@/context/SettingsContext";
import { AuthProvider } from "@/context/AuthContext";
import { PublicLayout } from "@/layouts/PublicLayout";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { ScrollToTop } from "@/components/ScrollToTop";
import { useLocation } from "react-router-dom";
import Home from "@/pages/Home";
import PremiumGuessing from "@/pages/PremiumGuessing";
const Results = lazy(() => import("@/pages/Results"));
const Charts = lazy(() => import("@/pages/Charts"));
const ChartDetail = lazy(() => import("@/pages/ChartDetail"));
const ChartRecordPage = lazy(() => import("@/pages/ChartDetail").then((m) => ({ default: m.ChartRecordPage })));
const LiveUpdate = lazy(() => import("@/pages/LiveUpdate"));
const Records = lazy(() => import("@/pages/Records"));
const Contact = lazy(() => import("@/pages/Contact"));
const InfoPage = lazy(() => import("@/pages/InfoPage"));
const ListMarket = lazy(() => import("@/pages/ListMarket"));
const ClientPanel = lazy(() => import("@/pages/ClientPanel"));
const NotFound = lazy(() => import("@/pages/NotFound"));
const AdminLogin = lazy(() => import("@/pages/admin/Login"));
const AdminDashboard = lazy(() => import("@/pages/admin/Dashboard"));

const ADMIN_PATH = "/bgr-rkd@1";
const ADMIN_HASH = "#2$3R-9472";

function SecretLogin() {
  const { hash } = useLocation();
  let h = hash;
  try { h = decodeURIComponent(hash); } catch { /* keep raw */ }
  return h === ADMIN_HASH ? <AdminLogin /> : <NotFound />;
}

function App() {
  return (
    <SettingsProvider>
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Suspense fallback={<div className="min-h-[60vh]" />}>
          <Routes>
              <Route element={<PublicLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/live" element={<LiveUpdate />} />
                <Route path="/results" element={<Results />} />
                <Route path="/charts" element={<Charts />} />
                <Route path="/chart/:categoryId" element={<ChartDetail />} />
                <Route path="/panel-chart-record/:slug" element={<ChartRecordPage type="panel" />} />
                <Route path="/jodi-chart-record/:slug" element={<ChartRecordPage type="jodi" />} />
                <Route path="/records" element={<Records />} />
                <Route path="/premium-guessing" element={<PremiumGuessing />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/list-your-market" element={<ListMarket />} />
                <Route path="/client" element={<ClientPanel />} />
                <Route path="/info/:slug" element={<InfoPage />} />
              </Route>
              <Route path={ADMIN_PATH} element={<SecretLogin />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<PublicLayout />}>
                <Route path="*" element={<NotFound />} />
              </Route>
            </Routes>
          </Suspense>
          <Toaster position="top-center" richColors theme="dark" />
        </BrowserRouter>
      </AuthProvider>
    </SettingsProvider>
  );
}

export default App;
